import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { Caption1, Input } from '../styled/typography/typography'

const Password = ({
  id,
  onBlur,
  onChange,
  onKeyPress,
  placeholder,
  autoFocus,
  showHint
}) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className={`password-container ${!showPassword ? 'visible' : ''}`}>
      <Input
        type={showPassword ? 'text' : 'password'}
        id={id}
        className="password"
        onBlur={onBlur}
        onChange={onChange}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        autoFocus={autoFocus}
      />

      <div
        tabIndex='0'
        aria-hidden='true'
        data-for={`password-tip-${id}`}
        data-tip={`Click to ${showPassword ? 'hide' : 'show'} password`}
        className='toggle-password'
        onKeyPress={() => {
          setShowPassword(!showPassword)
        }}
        onClick={() => {
          setShowPassword(!showPassword)
        }}
      />

      <ReactTooltip
        id={`password-tip-${id}`}
        effect="solid"
        getContent={
          () => 'Click to' + (showPassword ? ' hide' : ' show') + ' password'
        }
      />

      {showHint && (
        <Caption1 className="password-hint">Minimum 8 characters</Caption1>
      )}
    </div>
  )
}

Password.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  showHint: PropTypes.bool
}

export default Password
